import config from '@config'
import { JSONWidgetType as TeaserStandardVerticalJSONWidgetType } from '@widgets/TeaserStandardVertical'

import {
  ExecuteQuery,
  getAureusBatchRecommendations,
  getSectionWithAureusEnvironment,
  Purpose,
  QueryFactory,
} from '..'

interface AureusMostReadItem extends Record<string, unknown> {
  aureusOfferId: string
  articleID: string
  teasers: {
    standardVertical: TeaserStandardVerticalJSONWidgetType
  }
}

const {
  publication: { publication },
} = config

export const queryKey = 'polaris-popular'

export const createQuery = (({
  contentBlacklist,
  purpose = 'reference',
}: {
  contentBlacklist: string
  purpose: Purpose
}) =>
  ({
    [queryKey]: {
      resultsLimit: 3,
      context: {
        section: getSectionWithAureusEnvironment(
          `polaris${publication === 'romandie' ? '-romandie' : ''}-popular`,
        ),
        purpose,
        contentBlacklist,
      },
    },
  }) as const) satisfies QueryFactory<typeof queryKey>

export const executeQuery = (async (
  queryOptions: Parameters<typeof createQuery>[0],
  options?: Record<string, unknown>,
) => {
  try {
    const result = (
      await getAureusBatchRecommendations<typeof queryKey, AureusMostReadItem>(
        createQuery(queryOptions),
        options,
      )
    ).results[queryKey]

    if (!Array.isArray(result?.recommendations)) {
      return
    }

    return result.recommendations
  } catch (err) {
    console.error(err)
  }
}) satisfies ExecuteQuery<typeof queryKey>
